import axios from 'axios';
import { serialize } from 'object-to-formdata';

import { handleInterceptorErrors } from 'common/utils/api';

const CancelToken = axios.CancelToken;
let cancellableRequests = {};

const API = axios.create({
    baseURL: import.meta.env.VITE_SUNPAL_API_URL,
});

API.cancelAll = () => {
    Object.keys(cancellableRequests).forEach((key) => {
        cancellableRequests[key]();
        delete cancellableRequests[key];
    });
};

API.interceptors.request.use((req) => {
    const customId = `${new Date().getTime()}`;
    req.headers['api-key'] = import.meta.env.VITE_SUNPAL_API_KEY;
    if (
        req.headers['Content-Type'] === 'multipart/form-data' &&
        ['post', 'put', 'patch'].includes(req.method)
    )
        req.data = serialize(req.data, { indices: true });
    req.customId = customId;
    req.cancelToken = new CancelToken(function executor(c) {
        cancellableRequests[customId] = c;
    });

    return req;
});

API.interceptors.response.use(
    (res) => {
        delete cancellableRequests[res.config.customId];
        return res;
    },
    (error) => handleInterceptorErrors(cancellableRequests, error, true),
);

export default API;
